import {
  GETACTIVEUSER,
  GETROLES,
  GETSUPERVISOR,
  ADDUSER,
  GETAPPROVALUSER,
  APPROVALUSER,
  CHANGE_PASSWORD,
  UPDATEUSERREQUEST,
  DELETEUSERREQUEST,
} from "../../common/constants/endpoints";
import API from "../../helpers/API";
import {
  SET_GET_ACTIVE_USER,
  SET_GET_APPROVAL_USER,
  SET_ROLE_BY_DEPT,
  SET_SUPERVISOR_BY_ROLE,
  SET_CHANGE_PWD_MODAL,
} from "../../common/constants/ActionTypes";
import { logout } from "../../common/actions/commonActions";
import label from "../labels/users_en.json";
import { toastr } from "react-redux-toastr";
import { handleError, handleResponseMessage } from "../../common/actions/commonActions";

export const getAllRoles = () => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;

    let response;
    try {
      response = await API.get(GETROLES, {
        headers: { Authorization: `Bearer ${token}` },
      });
      dispatch({
        type: SET_ROLE_BY_DEPT,
        payload: response.data,
      });
    } catch (error) {
      handleError(error);
    }
  };
};
export const getSupervisorByDeptAndRoleId = (deptid, roleid) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(`${GETSUPERVISOR}/${deptid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      dispatch({
        type: SET_SUPERVISOR_BY_ROLE,
        payload: response.data,
      });
    } catch (error) {
      handleError(error);
    }
  };
};

export const addUser = (newuserDetails, props) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.post(ADDUSER, newuserDetails, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // dispatch(getAllApprovalUser());
      // dispatch(getAllUser());
      handleResponseMessage(response);
      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};
export const getAllUser = () => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(GETACTIVEUSER, {
        headers: { Authorization: `Bearer ${token}` },
      });
      dispatch({
        type: SET_GET_ACTIVE_USER,
        payload: response.data,
      });
    } catch (error) {
      handleError(error);
    }
  };
};
export const getAllApprovalUser = () => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let userId = session.userId;
    let response;
    try {
      response = await API.get(`${GETAPPROVALUSER}/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      dispatch({
        type: SET_GET_APPROVAL_USER,
        payload: response.data,
      });
    } catch (error) {
      handleError(error);
    }
  };
};
export const updateRequest = (newuserDetails, props) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;

    try {
      await API.patch(UPDATEUSERREQUEST, newuserDetails, {
        headers: { Authorization: `Bearer ${token}` },
      });
      dispatch(getAllApprovalUser());
      dispatch(getAllUser());
      toastr.success(label.User_update_successfully_and_reuest_sent);
    } catch (error) {
      handleError(error);
    }
  };
};
export const deleteRequest = (id, props) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;

    try {
      await API.patch(
        `${DELETEUSERREQUEST}/${id}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      dispatch(getAllApprovalUser());
      dispatch(getAllUser());
      toastr.success(label.User_Deleted_successfully);
    } catch (error) {
      handleError(error);
    }
  };
};
export const approvalUserRequest = (requestBody) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.post(APPROVALUSER, requestBody, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // dispatch(getAllApprovalUser());
      // dispatch(getAllUser());
      // toastr.success(response.data.message);
      handleResponseMessage(response);
    } catch (error) {
      handleError(error);
    }
  };
};

export const setChangePasswordFlg = (flag) => {
  return async (dispatch) => {
    dispatch({
      payload: flag,
      type: SET_CHANGE_PWD_MODAL,
    });
  };
};

export const ChangePasswordRequest = (data, props) => {
  return async (dispatch) => {
    let response;
    try {
      const session = JSON.parse(sessionStorage.getItem("session"));
      const token = session.jwtResponse && session.jwtResponse.token;
      response = await API.post(CHANGE_PASSWORD, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      dispatch({
        payload: false,
        type: SET_CHANGE_PWD_MODAL,
      });
      if (response.status === 200) {
        toastr.success(label.Kindly_relogin_new_password);
      }
      if (response.status === 200) {
        toastr.success(label.Password_updated_successfully);
        dispatch(logout(props));
      }
    } catch (error) {
      handleError(error);
    }
  };
};
